import { render } from "./TableHeaderItem.vue?vue&type=template&id=b8bc4444"
import script from "./TableHeaderItem.vue?vue&type=script&lang=ts"
export * from "./TableHeaderItem.vue?vue&type=script&lang=ts"
script.render = render

export default script